import { Typography } from "@mui/material";
import { YSButton } from "../../uikit/YSButton";
import { Box } from "@mui/material";
import { BtnGroupStyle } from "../../Theme";
import High from "../../images/icons/High";
import Moderate from "../../images/icons/Moderate";
import Low from "../../images/icons/Low";
import { AdherenceReview } from "../../Apis/AuthApiServices";
import { useState } from "react";
import YSSnackBar from "../../uikit/YSSnackBar";

export default function AIMedInfo({ adherenceData }: any) {
  const [madeAClick, setMadeAClick] = useState(false);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleReview = async (isAgree: Boolean) => {
    try {
      const params: any = new URLSearchParams();
      params.append("agreeFlag", isAgree);
      params.append(
        "predictionId",
        adherenceData?.medicalAdherencePredictionId
      );
      params.append("degreeOfAgreement", isAgree ? 2 : -2);
      const result = await AdherenceReview(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setMadeAClick(true);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const renderAdherenceMessages = () => {
    const adherenceFeatures: string[] = adherenceData?.adherenceFeatures;
    return (
      <Box marginTop={2} borderRadius={1} bgcolor="#44799c1a" padding={2}>
        <Typography
          fontSize={14}
          color="primary"
          variant="subtitle2"
          fontWeight={600}
        >
          Reasons for low adherence and suggestions:
        </Typography>
        <ul>
          {adherenceFeatures?.map((each: string, index: number) =>
            each ? (
              <li style={{ fontSize: 12 }} key={index}>
                {each}
              </li>
            ) : null
          )}
        </ul>
      </Box>
    );
  };
  return (
    <>
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"left"}
        justifyContent="center"
        textAlign="left"
      >
        {parseFloat(adherenceData?.percentageOfAdherence) >= 80 ? (
          <>
            <Box
              display="flex"
              justifyContent={"space-around"}
              alignItems={"center"}
              width={"100%"}
            >
              <div>
                <High />
              </div>
              <Typography
                variant="h3"
                color="#33B469"
                borderRadius={2}
                border={1}
                textAlign="center"
                padding={3}
              >
                <Typography
                  textAlign="center"
                  fontWeight={500}
                  color="#000"
                  variant="body2"
                >
                  AI Prediction
                </Typography>
                {adherenceData?.percentageOfAdherence ?? 0}%
              </Typography>
            </Box>
            <Typography
              textAlign="center"
              margin={1}
              variant="h5"
              color="primary"
            >
              Congratulations!
            </Typography>
            <Typography fontSize={17} variant="subtitle2" fontWeight={400}>
              Based on our AI prediction model, there is a high probability that
              the patient will adhere to&nbsp;
              <strong style={{}}>{adherenceData?.drugName}</strong>.
            </Typography>
          </>
        ) : parseFloat(adherenceData?.percentageOfAdherence) >= 50 ? (
          <>
            <Box
              display="flex"
              justifyContent={"space-around"}
              alignItems={"center"}
              width={"100%"}
            >
              <div>
                <Moderate />
              </div>
              <Typography
                variant="h3"
                color="#E59E33"
                borderRadius={2}
                textAlign={"center"}
                border={1}
                padding={3}
              >
                <Typography
                  textAlign="center"
                  fontWeight={500}
                  color="#000"
                  variant="body2"
                >
                  AI Prediction
                </Typography>
                {adherenceData?.percentageOfAdherence ?? 0}%
              </Typography>
            </Box>
            <Typography fontSize={17} variant="subtitle2" fontWeight={400}>
              According to our AI prediction model, the patient has a moderate
              probability of adhering to&nbsp;
              <strong>{adherenceData?.drugName}</strong>, which could impact
              their health.
            </Typography>
            {adherenceData?.adherenceFeatures?.length > 0 &&
              renderAdherenceMessages()}
          </>
        ) : (
          <>
            <Box
              display="flex"
              justifyContent={"space-around"}
              alignItems={"center"}
              width={"100%"}
            >
              <div>
                <Low />
              </div>
              <Typography
                variant="h3"
                color="error"
                borderRadius={2}
                border={1}
                padding={3}
                textAlign={"center"}
              >
                <Typography
                  textAlign="center"
                  fontWeight={500}
                  color="#000"
                  variant="body2"
                >
                  AI Prediction
                </Typography>
                {adherenceData?.percentageOfAdherence ?? 0}%
              </Typography>
            </Box>
            <Typography fontSize={17} variant="subtitle2" fontWeight={400}>
              Based on our AI prediction model, there is a very low probability
              that the patient will adhere to&nbsp;
              <strong>{adherenceData?.drugName}</strong>, which could seriously
              impact their health.
            </Typography>
            {adherenceData?.adherenceFeatures?.length > 0 &&
              renderAdherenceMessages()}
          </>
        )}

        <BtnGroupStyle marginBottom={2} marginTop={2} className="center">
          {!madeAClick ? (
            <>
              <Typography
                width={"100%"}
                variant="subtitle2"
                fontWeight={400}
                marginBottom={1}
              >
                Do you agree or disagree on what AI is saying?
              </Typography>
              <YSButton
                className={""}
                disabled={madeAClick}
                children={"Agree"}
                onClick={() => handleReview(true)}
                variant={"contained"}
                size={"medium"}
              />
              <YSButton
                className={""}
                disabled={madeAClick}
                children={"Disagree"}
                onClick={() => handleReview(false)}
                variant={"outlined"}
                size={"medium"}
              />
            </>
          ) : (
            <Typography margin={0} variant="h6" color="primary">
              Thank you for your valuable feedback!
            </Typography>
          )}
        </BtnGroupStyle>

        <Box display={"flex"} justifyContent="space-between">
          <Typography
            textAlign="left"
            variant="body2"
            color="#666666"
            fontWeight={500}
            fontSize={10}
            fontStyle={"italic"}
          >
            Disclaimer:
          </Typography>{" "}
          <Typography
            textAlign="left"
            variant="body2"
            fontSize={10}
            color="#666666"
            fontStyle={"italic"}
          >
            This service is based on AI, and AI models can produce both correct
            and incorrect predictions. We encourage you to use your own best
            judgment while using this service.
          </Typography>
        </Box>
      </Box>

      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
